<div class="participants-tab">

	<div class="bulk-bar" *ngIf="canEdit && selection.hasValue()">
		<span class="selected-count">
			{{ selection.selected.length }} {{ 'selezionati' | translate }}
		</span>
		<span fxFlex></span>
		<button mat-raised-button
				class="brand-btn"
				[disabled]="bulkLoading"
				(click)="bulkUpdate(1)">
			<mat-icon>check_circle</mat-icon>
			<span class="ml-4">{{ 'Conferma presenti' | translate }}</span>
		</button>
		<button mat-raised-button
				color="warn"
				[disabled]="bulkLoading"
				(click)="bulkUpdate(0)">
			<mat-icon>cancel</mat-icon>
			<span class="ml-4">{{ 'Marca assenti' | translate }}</span>
		</button>
	</div>

	<div class="loading-row" *ngIf="loading">
		<mat-spinner [diameter]="28"></mat-spinner>
	</div>

	<div class="empty-row" *ngIf="!loading && rows.length === 0">
		{{ 'Nessun partecipante' | translate }}
	</div>

	<table mat-table [dataSource]="rows" [trackBy]="trackById" class="participants-table" *ngIf="!loading && rows.length > 0">

		<ng-container matColumnDef="select">
			<th mat-header-cell *matHeaderCellDef>
				<mat-checkbox (change)="masterToggle()"
							[checked]="isAllSelected()"
							[indeterminate]="selection.hasValue() && !isAllSelected()">
				</mat-checkbox>
			</th>
			<td mat-cell *matCellDef="let row">
				<mat-checkbox (click)="$event.stopPropagation()"
							(change)="$event && selection.toggle(row.id)"
							[checked]="selection.isSelected(row.id)">
				</mat-checkbox>
			</td>
		</ng-container>

		<ng-container matColumnDef="description">
			<th mat-header-cell *matHeaderCellDef>{{ 'Nominativo' | translate }}</th>
			<td mat-cell *matCellDef="let row">{{ row.description }}</td>
		</ng-container>

		<ng-container matColumnDef="trip_booking_code">
			<th mat-header-cell *matHeaderCellDef>{{ 'Codice prenotazione' | translate }}</th>
			<td mat-cell *matCellDef="let row">
				<a [routerLink]="['/dataset/detail/trip_bookings', row.trip_booking_id]">{{ row.trip_booking_code }}</a>
			</td>
		</ng-container>

		<ng-container matColumnDef="age_range_code">
			<th mat-header-cell *matHeaderCellDef>{{ 'Età' | translate }}</th>
			<td mat-cell *matCellDef="let row">
				<span class="age-chip" [attr.data-age]="row.age_range_code">{{ row.age_range_code }}</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="presence">
			<th mat-header-cell *matHeaderCellDef>{{ 'Gestione presenza' | translate }}</th>
			<td mat-cell *matCellDef="let row">
				<button type="button"
						class="presence-icon"
						[class.is-present]="row.presence == 1"
						[class.is-absent]="row.presence != 1"
						[disabled]="!canEdit || row._updating"
						[matTooltip]="(row.presence == 1 ? 'Presenza confermata' : 'Presenza non confermata') | translate"
						(click)="togglePresence(row)">
					<span class="material-icons">person</span>
				</button>
			</td>
		</ng-container>

		<ng-container matColumnDef="last_presence_checked_at">
			<th mat-header-cell *matHeaderCellDef>{{ 'Ultimo check' | translate }}</th>
			<td mat-cell *matCellDef="let row">
				<span *ngIf="row.last_presence_checked_at">{{ row.last_presence_checked_at | date:'dd/MM/yyyy HH:mm' }}</span>
				<span *ngIf="!row.last_presence_checked_at" class="muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="note">
			<th mat-header-cell *matHeaderCellDef>{{ 'Note' | translate }}</th>
			<td mat-cell *matCellDef="let row">
				<span *ngIf="row.note" [matTooltip]="row.note" class="note-cell">{{ row.note }}</span>
				<span *ngIf="!row.note" class="muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="logs">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let row">
				<button mat-icon-button
						type="button"
						[disabled]="!hasLogs(row)"
						[matTooltip]="(hasLogs(row) ? 'Mostra log' : 'Nessun log disponibile') | translate"
						(click)="openLogs(row)">
					<mat-icon>history</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns" [class.is-present]="row.presence == 1"></tr>
	</table>
</div>
